/* appState.svelte.ts generated by Svelte v5.55.3 */
import * as $ from 'svelte/internal/client';
import { db } from "../db";

let appState = $.state($.proxy({
	id: "singleton",
	activeChildId: null,
	onboardingCompleted: false
}));

export function getAppState() {
	return $.get(appState);
}

export async function loadAppState() {
	const saved = await db.appState.get("singleton");

	if (saved) $.set(appState, saved, true);
}

export async function setActiveChildId(id) {
	$.set(appState, { ...$.get(appState), activeChildId: id }, true);
	await db.appState.put(JSON.parse(JSON.stringify($.get(appState))));
}

export async function setOnboardingCompleted(completed) {
	$.set(appState, { ...$.get(appState), onboardingCompleted: completed }, true);
	await db.appState.put(JSON.parse(JSON.stringify($.get(appState))));
}

export async function resetAppState() {
	$.set(
		appState,
		{
			id: "singleton",
			activeChildId: null,
			onboardingCompleted: false
		},
		true
	);

	await db.appState.delete("singleton");
}